import { type AdminUser, AdminUserSchema, type AdminUserUpdateInput } from '@cult/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../../../lib/api-client';
import { adminKeys } from '../../admin-keys';

export type UpdateUserInput = {
  id: string;
  patch: AdminUserUpdateInput;
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation<AdminUser, Error, UpdateUserInput>({
    mutationFn: async ({ id, patch }) => {
      const raw = await apiFetch<unknown>(`/admin/users/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(patch),
      });
      return AdminUserSchema.parse(raw);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminKeys.all });
    },
  });
};
